const initialState = {

    states: {},
  }
  
  const demographics = (state = initialState, action) => {
    switch (action.type) {
  
      case 'SET_DEMO_CATEGORIES_LIST':
        return {
          ...state,
          demoGraphicsCategoriesListSuccess : action.response.success,
          demoGraphicsCategoriesList : action.response.demoCategorieslist,
        }
      
        case 'SET_DEMO_ADD_CATEGORIES_SUCCESS':
        return {
          ...state,
          demoGraphicsCategoriesAddSuccess : action.response.success,
          demoGraphicsCategoriesResultData : action.response.categoryResultData,
          demoGraphicsCategoriesSuccessmessage : action.response.message,
        }

        case 'SET_DEMO_ADD_CATEGORIES_FAIL':
        return {
          ...state,
          demoGraphicsCategoriesAddSuccess : action.response.success,
          demoGraphicsCategoriesFailmessage : action.response.message,
        }

        case 'SET_EMPTY_DEMO_ADD_CATEGORIES_RES':
        return {
          ...state,
          demoGraphicsCategoriesAddSuccess : null,
          demoGraphicsCategoriesResultData : null,
          demoGraphicsCategoriesSuccessmessage : null,
          demoGraphicsCategoriesFailmessage : null,
          demoGraphicsCategoriesUpdateSuccess : null,
          demoGraphicsCategoriesUpdateSuccessMessage : null,
          demoGraphicsCategoriesUpdateFailMessage : null
        }

        case 'SET_DEMO_CATEGORIES_QUESTIONS_LIST':
        return{
          ...state,
          demoGraphicsCategoriesQuesListSuccess :  action.response.success,
          demoGraphicsCategoriesQuesListData :  action.response.questionData,
        }

        case 'SET_DEMO_UPDATE_CATEGORIES_SUCCESS':
        return{
          ...state,
          demoGraphicsCategoriesUpdateSuccess : action.response.success,
          demoGraphicsCategoriesUpdateSuccessMessage : action.response.message,
        }

        case 'SET_DEMO_UPDATE_CATEGORIES_FAIL':
        return{
          ...state,
          demoGraphicsCategoriesUpdateSuccess : action.response.success,
          demoGraphicsCategoriesUpdateFailMessage : action.response.message,
        }

        //questions
        case 'SET_DEMO_ADD_QUESTIONS_SUCCESS':
        return{
          ...state,
          demoGraphicsQuestionAddSuccess : action.response.success,
          demoGraphicsQuestionSuccessmessage : action.response.message,
        }

        case 'SET_DEMO_ADD_QUESTIONS_Fail':
        return{
          ...state,
          demoGraphicsQuestionAddSuccess : action.response.success,
          demoGraphicsQuestionFailmessage : action.response.message,
        }

        case 'SET_EMPTY_DEMO_ADD_QUESTION_RES':
        return{
          ...state,
          demoGraphicsQuestionAddSuccess : null,
          demoGraphicsQuestionSuccessmessage : null,
          demoGraphicsQuestionFailmessage : null,
        }

        case 'SET_DEMO_CATEGORIES_QUESTIONS_OPTIONS_LIST':
        return {
          ...state,
          demoGraphicsCatQuesOptionsListSuccess :  action.response.success,
          demoGraphicsCatQuesOptionsListData :  action.response.optionData,
        }

        case 'SET_DEMO_UPDATE_QUESTION_SUCCESS':
        return{
          ...state,
          demoGraphicsQuestionUpdateSuccess : action.response.success,
          demoGraphicsQuestionsUpdateSuccessMessage : action.response.message,
        }

        case 'SET_DEMO_UPDATE_QUESTION_FAIL':
        return{
          ...state,
          demoGraphicsQuestionUpdateSuccess : action.response.success,
          demoGraphicsQuestionsUpdateFailMessage : action.response.message,
        }

        case 'SET_EMPTY_DEMO_QUESTIONS_RESPONSE':
        return{
          ...state,
          demoGraphicsQuestionUpdateSuccess : null,
          demoGraphicsQuestionsUpdateSuccessMessage : null,
          demoGraphicsQuestionsUpdateFailMessage : null
        }

        //option....
        case 'SET_DEMO_ADD_OPTIONS_SUCCESS':
        return{
          demoGraphicsOptionAddSuccess : action.response.success,
          demoGraphicsOptionSuccessmessage : action.response.message,
        }

        case 'SET_DEMO_ADD_OPTIONS_Fail':
        return{
          demoGraphicsOptionAddSuccess : action.response.success,
          demoGraphicsOptionFailmessage : action.response.message,
        }

        case 'SET_EMPTY_OPTION_RESPONSE':
        return{
          demoGraphicsOptionAddSuccess : null,
          demoGraphicsOptionSuccessmessage : null,
          demoGraphicsOptionFailmessage : null,
          demoGraphicsOptionUpdateSuccess : null,
          demoGraphicsOptionUpdateSuccessMessage : null,
          demoGraphicsOptionUpdateFailMessage : null,
          demoGraphicsSubOptionAddSuccess : null,
          demoGraphicsSubOptionSuccessmessage : null,
          demoGraphicsSubOptionFailmessage : null
        }

        case 'SET_DEMO_UPDATE_OPTION_SUCCESS':
        return{
          ...state,
          demoGraphicsOptionUpdateSuccess : action.response.success,
          demoGraphicsOptionUpdateSuccessMessage : action.response.message,
        }

        case 'SET_DEMO_UPDATE_OPTION_FAIL':
        return{
          ...state,
          demoGraphicsOptionUpdateSuccess : action.response.success,
          demoGraphicsOptionUpdateFailMessage : action.response.message,
        }

        case 'SET_DEMO_CATEGORIES_SUB_QUESTIONS_LIST':
        return{
          ...state,
          demoGraphicsSubQuesOptionsListSuccess :  action.response.success,
          demoGraphicsSubQuesOptionsListData :  action.response.demoSubQuestionList,
          demoGraphicsEditSubQuestionData : null,
          showDemoGraphicsEditSubQuestion : false,
        }

        case 'SET_DEMO_ADD_SUB_QUESTIONS_SUCCESS':
        return{
          ...state,
          demoGraphicsSubQuestionAddSuccess : action.response.success,
          demoGraphicsSubQuestionSuccessmessage : action.response.message,
        }

        case 'SET_DEMO_ADD_SUB_QUESTIONS_Fail':
        return{
          ...state,
          demoGraphicsSubQuestionAddSuccess : action.response.success,
          demoGraphicsSubQuestionFailmessage : action.response.message,
        }

        case 'SET_EMPTY_SUB_QUESTION_RESPONSE':
        return{
          ...state,
          demoGraphicsSubQuestionAddSuccess : null,
          demoGraphicsSubQuestionSuccessmessage :  null,
          demoGraphicsSubQuestionFailmessage : null,
          subQuestionUpdateSuccess : null,
          subQuestionUpdateSuccessMessage : null,
          subQuestionUpdateFailMessage : null
        }

        case 'SET_EDIT_SUB_QUESTION_DATA':
        return{
          ...state,
          showDemoGraphicsEditSubQuestion : true,
          demoGraphicsEditSubQuestionSuccess : true,
          demoGraphicsEditSubQuestionData : action.response.subQuestionData,
        }

        case 'SET_DEMO_UPDATE_SUB_QUES_SUCCESS':
        return{
          ...state,
          subQuestionUpdateSuccess : action.response.success,
          subQuestionUpdateSuccessMessage : action.response.message,
        }

        case 'SET_DEMO_UPDATE_SUB_QUES_FAIL':
        return{
          ...state,
          subQuestionUpdateSuccess : action.response.success,
          subQuestionUpdateFailMessage : action.response.message,
        }

        case 'SET_SUB_OPTIONS_LIST':
        return{
          ...state,
          demoGraphicsCatSubQuesOptionsListSuccess :  action.response.success,
          demoGraphicsCatSubQuesOptionsListData :  action.response.subOptionData,
          SubOptionEditData : null,
          showEditSubOption : false, 
        }

        case 'SET_DEMO_ADD_SUB_OPTION_SUCCESS':
        return{
          ...state,
          demoGraphicsSubOptionAddSuccess : action.response.success,
          demoGraphicsSubOptionSuccessmessage : action.response.message,
        }

        case 'SET_DEMO_ADD_SUB_OPTION_FAIL':
        return{
          ...state,
          demoGraphicsSubOptionAddSuccess : action.response.success,
          demoGraphicsSubOptionFailmessage : action.response.message,
        }

        case 'SET__SUB_OPTION_EDIT_DATA':
        return{
          ...state,
          showEditSubOption : true, 
          SubOptionEditData : action.response.subOption,
        }

        case 'SET_SUB_OPTION_UPDATE_SUCCESS_RES':
        return{
          ...state,
          subOptionUpdateSuccess : action.response.success,
          subOptionUpdateSuccessMessage : action.response.message,
        }

        case 'SET_SUB_OPTION_UPDATE_FAIL_RES':
        return{
          ...state,
          subOptionUpdateSuccess : action.response.success,
          subOptionUpdateFailMessage : action.response.message,
        }

        case 'SET_EMPTY_SUB_OPTION_RESPONSE':
        return {
          ...state,
          subOptionUpdateSuccess : null,
          subOptionUpdateSuccessMessage : null,
          subOptionUpdateFailMessage : null
        }

        case 'SET_DEMO_CATEGORIES_SEC_SUB_QUESTIONS_LIST':
        return {
          ...state,
          demoGraphicsSecSubQuesOptionsListSuccess :  action.response.success,
          demoGraphicsSecSubQuesOptionsListData :  action.response.demoSecSubQuestionList,
          demoGraphicsEditSecSubQuestionData : null,
          showDemoGraphicsEditSecSubQuestion : false,
        }

        case 'SET_DEMO_ADD_SEC_SUB_QUESTIONS_SUCCESS':
        return{
          ...state,
          demoGraphicsSecSubQuestionAddSuccess : action.response.success,
          demoGraphicsSecSubQuestionSuccessmessage : action.response.message,
        }

        case 'SET_DEMO_ADD_SEC_SUB_QUESTIONS_Fail':
        return{
          ...state,
          demoGraphicsSecSubQuestionAddSuccess : action.response.success,
          demoGraphicsSecSubQuestionFailmessage : action.response.message,
        }

        case 'SET_EMPTY_SEC_SUB_QUESTION_RESPONSE':
        return{
          ...state,
          demoGraphicsSecSubQuestionAddSuccess : null,
          demoGraphicsSecSubQuestionSuccessmessage : null,
          demoGraphicsSecSubQuestionFailmessage : null,
          secSubQuestionUpdateSuccess : null,
          secSubQuestionUpdateSuccessMessage : null,
          secSubQuestionUpdateFailMessage : null
        }

        case 'SET_EDIT_SEC_SUB_QUESTION_DATA':
        return{
          ...state,
          showDemoGraphicsEditSecSubQuestion : true,
          demoGraphicsEditSecSubQuestionSuccess : true,
          demoGraphicsEditSecSubQuestionData : action.response.secSubQuestionData,
        }

        case 'SET_DEMO_UPDATE_SEC_SUB_QUES_SUCCESS':
        return{
          ...state,
          secSubQuestionUpdateSuccess : action.response.success,
          secSubQuestionUpdateSuccessMessage : action.response.message,
        }

        case 'SET_DEMO_UPDATE_SEC_SUB_QUES_FAIL':
        return{
          ...state,
          secSubQuestionUpdateSuccess : action.response.success,
          secSubQuestionUpdateFailMessage : action.response.message,
        }

        case 'SET_SEC_SUB_OPTIONS_LIST':
        return{
          ...state,
          demoGraphicsCatSecSubQuesOptionsListSuccess :  action.response.success,
          demoGraphicsCatSecSubQuesOptionsListData :  action.response.secSubOptionData,
          //SubOptionEditData : null,
          //showEditSubOption : false, 
        }
  
        case 'SET_DEMO_ADD_SEC_SUB_OPTION_SUCCESS':
        return{
          ...state,
          demoGraphicsSecSubOptionAddSuccess : action.response.success,
          demoGraphicsSecSubOptionSuccessmessage : action.response.message,
        }

        case 'SET_DEMO_ADD_SEC_SUB_OPTION_FAIL':
        return{
          ...state,
          demoGraphicsSecSubOptionAddSuccess : action.response.success,
          demoGraphicsSecSubOptionFailmessage : action.response.message,
        }

        case 'SET_EMPTY_SEC_SUB_OPTION_RESPONSE':
        return{
          ...state,
          demoGraphicsSecSubOptionAddSuccess : null,
          demoGraphicsSecSubOptionSuccessmessage : null,
          demoGraphicsSecSubOptionFailmessage : null,
          secSubOptionUpdateSuccess : null,
          secSubOptionUpdateSuccessMessage : null,
          secSubOptionUpdateFailMessage : null,
        }

        case 'SET_SEC_SUB_OPTION_EDIT_DATA':
        return{
          ...state,
          showEditSecSubOption : true, 
          secSubOptionEditData : action.response.secSubOption,
        }

        case 'SET_SEC_SUB_OPTION_UPDATE_SUCCESS_RES':
        return{
          ...state,
          secSubOptionUpdateSuccess : action.response.success,
          secSubOptionUpdateSuccessMessage : action.response.message,
        }

        case 'SET_SEC_SUB_OPTION_UPDATE_FAIL_RES':
        return{
          ...state,
          secSubOptionUpdateSuccess : action.response.success,
          secSubOptionUpdateFailMessage : action.response.message,
        }

      default:
        return state;
    }
  };
  export default demographics;
  


// WEBPACK FOOTER //
// ./src/reducers/demographics.js